export enum WhatIfTypeKey {
  BusinessSale = '1000',
  RealEstateSale = '1001',
  MiscellaneousAssetSale = '1002',
  IncomeChanges = '1200',
  EstatePlanningLifeExpectancies = '1400',
  EstateTaxesChange = '1401',
  EstatePlanningCharitableDonations = '1402',
  AnnuityPurchase = '1500',
  Windfall = '1501',
  PensionChange = '1700',
  LivingExpensesChange = '1800',
}

export const WHATIF_GROUP_LABEL = {
  ProfileChanges: 'Profile Changes',
};
